import { AppModal } from 'shared/UI/UIKit/Modal';
import { AppForm, AppFormItem, formRules } from 'shared/UI/UIKit/Form';
import { AppInput } from 'shared/UI/UIKit/Input';
import { AppMultipleSelect, AppSelect } from 'shared/UI/UIKit/Select';
import { AppButton } from 'shared/UI/UIKit/Button';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { useAddRoomLessonModal, type AddRoomLessonModalProps } from '../model';

export const AddRoomLessonModal = (props: AddRoomLessonModalProps) => {
  const {
    state: { form, loading, subjectsLoading, buildingsLoading, subjectOptions, buildingOptions },
    methods: { hideModal, onSubmit },
  } = useAddRoomLessonModal(props);

  return (
    <AppModal
      visible={props.visible}
      onCancel={hideModal}
      destroyOnClose
      loading={loading}
      title="Создать аудиторию"
      maskClosable={false}
      footer={
        <AppFlex direction="row">
          <AppButton onClick={onSubmit}>Сохранить</AppButton>
          <AppButton type="outline" onClick={hideModal}>
            Отмена
          </AppButton>
        </AppFlex>
      }
      content={
        <AppForm form={form}>
          <AppFormItem rules={formRules.requiredNumber} label="Здание" name="buildingId">
            <AppSelect
              options={buildingOptions}
              loading={buildingsLoading}
              placeholder="Выберите здание"
            />
          </AppFormItem>

          <AppFormItem rules={formRules.required} label="Номер аудитории" name="number">
            <AppInput placeholder="Введите номер аудитории" />
          </AppFormItem>

          <AppFormItem rules={formRules.required} label="Название аудитории" name="name">
            <AppInput placeholder="Введите название аудитории" />
          </AppFormItem>

          <AppFormItem
            label="Список предметов, допустимых для аудитории"
            name="subjectsIds"
            rules={formRules.requiredArray}
          >
            <AppMultipleSelect
              options={subjectOptions}
              loading={subjectsLoading}
              style={{ minHeight: '40px', height: 'auto' }}
            />
          </AppFormItem>
        </AppForm>
      }
    />
  );
};
